// Pill component for an intent label. Color is derived from the intent itself —
// caller doesn't pick. Keep it small + restrained — these stack densely in the inbox.

import { INTENT_LABELS, type ReplyIntent } from '@stax/shared';

interface Props {
  intent: ReplyIntent;
}

export function IntentBadge({ intent }: Props) {
  return (
    <span className={`intent-badge intent-badge--${intent}`}>{INTENT_LABELS[intent]}</span>
  );
}
